import ApplicationSerializer from 'lumen/serializers/application';

export default class OtaHotelInfoSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    return 'ota-hotel-info';
  }
}
